module.exports = __webpack_public_path__ + "static/media/nwm.376b607d.png";